/** eslint-disable */
const keyStrUriSafe = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$'
const baseReverseDic = {}

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {}
    for (let i = 0; i < alphabet.length; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i
    }
  }
  return baseReverseDic[alphabet][character]
}

function _compress(uncompressed, bitsPerChar, getCharFromInt) {
  // eslint-disable-next-line
  if (uncompressed == null) return ''
  let i, value
  const context_dictionary = {}
  const context_dictionaryToCreate = {}
  let context_c = ''
  let context_wc = ''
  let context_w = ''
  let context_enlargeIn = 2
  let context_dictSize = 3
  let context_numBits = 2
  const context_data = []
  let context_data_val = 0
  let context_data_position = 0

  for (let ii = 0; ii < uncompressed.length; ii++) {
    context_c = uncompressed.charAt(ii)
    if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
      context_dictionary[context_c] = context_dictSize++
      context_dictionaryToCreate[context_c] = true
    }

    context_wc = context_w + context_c
    if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
      context_w = context_wc
    } else {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
        if (context_w.charCodeAt(0) < 256) {
          for (i = 0; i < context_numBits; i++) {
            context_data_val = (context_data_val << 1)
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0
              context_data.push(getCharFromInt(context_data_val))
              context_data_val = 0
            } else {
              context_data_position++
            }
          }
          value = context_w.charCodeAt(0)
          for (i = 0; i < 8; i++) {
            context_data_val = (context_data_val << 1) | (value & 1)
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0
              context_data.push(getCharFromInt(context_data_val))
              context_data_val = 0
            } else {
              context_data_position++
            }
            value = value >> 1
          }
        } else {
          value = 1
          for (i = 0; i < context_numBits; i++) {
            context_data_val = (context_data_val << 1) | value
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0
              context_data.push(getCharFromInt(context_data_val))
              context_data_val = 0
            } else {
              context_data_position++
            }
            value = 0
          }
          value = context_w.charCodeAt(0)
          for (i = 0; i < 16; i++) {
            context_data_val = (context_data_val << 1) | (value & 1)
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0
              context_data.push(getCharFromInt(context_data_val))
              context_data_val = 0
            } else {
              context_data_position++
            }
            value = value >> 1
          }
        }
        context_enlargeIn--
        if (context_enlargeIn === 0) {
          context_enlargeIn = Math.pow(2, context_numBits)
          context_numBits++
        }
        delete context_dictionaryToCreate[context_w]
      } else {
        value = context_dictionary[context_w]
        for (i = 0; i < context_numBits; i++) {
          context_data_val = (context_data_val << 1) | (value & 1)
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0
            context_data.push(getCharFromInt(context_data_val))
            context_data_val = 0
          } else {
            context_data_position++
          }
          value = value >> 1
        }
      }
      context_enlargeIn--
      if (context_enlargeIn === 0) {
        context_enlargeIn = Math.pow(2, context_numBits)
        context_numBits++
      }
      context_dictionary[context_wc] = context_dictSize++
      context_w = String(context_c)
    }
  }

  if (context_w !== '') {
    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
      if (context_w.charCodeAt(0) < 256) {
        for (i = 0; i < context_numBits; i++) {
          context_data_val = (context_data_val << 1)
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0
            context_data.push(getCharFromInt(context_data_val))
            context_data_val = 0
          } else {
            context_data_position++
          }
        }
        value = context_w.charCodeAt(0)
        for (i = 0; i < 8; i++) {
          context_data_val = (context_data_val << 1) | (value & 1)
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0
            context_data.push(getCharFromInt(context_data_val))
            context_data_val = 0
          } else {
            context_data_position++
          }
          value = value >> 1
        }
      } else {
        value = 1
        for (i = 0; i < context_numBits; i++) {
          context_data_val = (context_data_val << 1) | value
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0
            context_data.push(getCharFromInt(context_data_val))
            context_data_val = 0
          } else {
            context_data_position++
          }
          value = 0
        }
        value = context_w.charCodeAt(0)
        for (i = 0; i < 16; i++) {
          context_data_val = (context_data_val << 1) | (value & 1)
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0
            context_data.push(getCharFromInt(context_data_val))
            context_data_val = 0
          } else {
            context_data_position++
          }
          value = value >> 1
        }
      }
      context_enlargeIn--
      if (context_enlargeIn === 0) {
        context_enlargeIn = Math.pow(2, context_numBits) // eslint-disable-line
        context_numBits++
      }
      delete context_dictionaryToCreate[context_w]
    } else {
      value = context_dictionary[context_w]
      for (i = 0; i < context_numBits; i++) {
        context_data_val = (context_data_val << 1) | (value & 1)
        if (context_data_position === bitsPerChar - 1) {
          context_data_position = 0
          context_data.push(getCharFromInt(context_data_val))
          context_data_val = 0
        } else {
          context_data_position++
        }
        value = value >> 1
      }
    }
    context_enlargeIn--
    if (context_enlargeIn === 0) {
      context_enlargeIn = Math.pow(2, context_numBits) // eslint-disable-line
      context_numBits++
    }
  }

  // Mark the end of the stream
  value = 2
  for (i = 0; i < context_numBits; i++) {
    context_data_val = (context_data_val << 1) | (value & 1)
    if (context_data_position === bitsPerChar - 1) {
      context_data_position = 0
      context_data.push(getCharFromInt(context_data_val))
      context_data_val = 0
    } else {
      context_data_position++
    }
    value = value >> 1
  }

  // Flush the last char
  // eslint-disable-next-line
  while (true) {
    context_data_val = (context_data_val << 1)
    if (context_data_position === bitsPerChar - 1) {
      context_data.push(getCharFromInt(context_data_val))
      break
    } else {
      context_data_position++
    }
  }
  return context_data.join('')
}

function _decompress(length, resetValue, getNextValue) {
  const dictionary = []
  let enlargeIn = 4
  let dictSize = 4
  let numBits = 3
  let entry = ''
  const result = []
  let w, c
  let next
  const data = { val: getNextValue(0), position: resetValue, index: 1 }

  function readBits(n) {
    let bits = 0
    const maxpower = Math.pow(2, n)
    let power = 1
    while (power !== maxpower) {
      const resb = data.val & data.position
      data.position >>= 1
      if (data.position === 0) {
        data.position = resetValue
        data.val = getNextValue(data.index++)
      }
      bits |= (resb > 0 ? 1 : 0) * power
      power <<= 1
    }
    return bits
  }

  for (let i = 0; i < 3; i++) {
    dictionary[i] = i
  }

  next = readBits(2)
    // eslint-disable-next-line
  switch (next) {
    case 0: c = String.fromCharCode(readBits(8)); break
    case 1: c = String.fromCharCode(readBits(16)); break
    case 2: return ''
  }
  dictionary[3] = c
  w = c
  result.push(c)

  // eslint-disable-next-line
  while (true) {
      // eslint-disable-next-line
    if (data.index > length) return ''
    next = readBits(numBits)
  // eslint-disable-next-line
    switch (next) {
      case 0:
        next = readBits(8)
        dictionary[dictSize++] = String.fromCharCode(next)
        next = dictSize - 1
        enlargeIn--
        break
      case 1:
        next = readBits(16)
        dictionary[dictSize++] = String.fromCharCode(next)
        next = dictSize - 1
        enlargeIn--
        break
      case 2:
        return result.join('')
    }

    if (enlargeIn === 0) {
      enlargeIn = Math.pow(2, numBits)
      numBits++
    }

    if (dictionary[next]) {
      entry = dictionary[next]
    } else {
      if (next === dictSize) {
        entry = w + w.charAt(0)
      } else {
        return null
      }
    }
    result.push(entry)

    dictionary[dictSize++] = w + entry.charAt(0)
    enlargeIn--

    if (enlargeIn === 0) {
      enlargeIn = Math.pow(2, numBits)
      numBits++
    }

    w = entry
  }
}

/**
 * 压缩字符串为 URL 安全的短字符串
 * @param {string} input
 * @returns {string}
 */
export function compress(input) {
    // eslint-disable-next-line
  if (input == null) return ''
  return _compress(input, 6, function (a) { return keyStrUriSafe.charAt(a) })
}

/**
 * 解压 URL 安全的压缩字符串
 * @param {string} input
 * @returns {string}
 */
export function decompress(input) {
    // eslint-disable-next-line
  if (input == null) return ''
    // eslint-disable-next-line
  if (input === '') return null
  input = input.replace(/ /g, '+')
  return _decompress(input.length, 32, function (index) { return getBaseValue(keyStrUriSafe, input.charAt(index)) })
}

export default { compress, decompress }
